import * as React from 'react';
import { cn } from '@/hen-ui/utils';
import { Text } from '@/hen-ui/atomics/Text';

export interface TimelineEventDescriptionProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  index: number;
  isLast: boolean;
}

const ICON_SIZE = '30px';

/**
 * TimelineEvent component renders a single event in the timeline.
 */
export const TimelineEventDescription = React.forwardRef<
  HTMLDivElement,
  TimelineEventDescriptionProps
>(({ index, isLast, className, children, ...props }, ref) => {
  return (
    <div className={cn('flex gap-xs', className)} ref={ref} {...props}>
      {/* Left column: Line container (same width as icon) */}
      <div
        className='flex-shrink-0 flex items-center justify-center'
        style={{ width: ICON_SIZE }}
      >
        {!isLast && (
          <span
            className='bg-neutral-500 w-0.5 h-full rounded-full'
            aria-hidden='true'
          />
        )}
      </div>

      {/* Right column: Description content */}
      <div className='flex-1 pb-md'>
        <Text tag='p' variant='b4' id={`timeline-event-${index}-description`}>
          {children}
        </Text>
      </div>
    </div>
  );
});

TimelineEventDescription.displayName = 'TimelineEventDescription';
